import { GET_ARCHIVED_EVENT_FS_OBJECTS } from 'actions/Types';

export default (state = [], action) => {
  if (action.type === `${GET_ARCHIVED_EVENT_FS_OBJECTS}_SUCCESS`) {
    return action.payload.items;
  }

  return state;
};
